import MInput from './components/formFields/MInput.vue';
import MTextArea from './components/formFields/MTextArea.vue';
import MInputDatepicker from './components/formFields/MInputDatepicker.vue';
import MSelect from './components/formFields/MSelect.vue';
import MLabeledSelect from './components/formFields/MLabeledSelect.vue';
import MChoice from './components/formFields/MChoice.vue';
import MChoices from './components/formFields/MChoices.vue';
import MCheckbox from './components/formFields/MCheckbox.vue';
import MInputNumber from './components/formFields/MInputNumber.vue';
import MTooltip from './components/formFields/MTooltip.vue';
import MErrors from './components/formFields/MErrors.vue';
import BaseDescription from './components/baseHeaderPartners/BaseDescription.vue';
import BaseHeaderComponent from './components/baseHeaderPartners/BaseHeaderComponent.vue';
import BaseHowItWorks from './components/baseHeaderPartners/BaseHowItWorks.vue';
import BaseMenu from './components/baseHeaderPartners/BaseMenu.vue';
import BaseTopBanner from './components/baseHeaderPartners/BaseTopBanner.vue';
import HowItWorksItem from './components/baseHeaderPartners/HowItWorksItem.vue';
import MenuItem from './components/baseHeaderPartners/MenuItem.vue';
import Faq from './components/faq/Faq.vue';
import FaqAccordion from './components/faq/FaqAccordion.vue';

import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';

const path = require('path');

export let buyout = {
	components: require('./components/buyout'),
	config: require('./config/buyout').config,
	store: require('./store/buyout'),
	utils: require('../js/buyout'),
	mixins: require('./mixins/buyout'),
	plugins: {
		i18n: require('./plugins/i18n').default,
		vuetify: require('./plugins/vuetify').default
	}
}

// for importing all components at once
export let Components = {
	MInput,
	MTextArea,
	MInputDatepicker,
	MSelect,
	MLabeledSelect,
	MChoice,
	MChoices,
	MCheckbox,
	MInputNumber,
	MTooltip,
	MErrors
}

// for importing only specific component
export {
	MInput,
	MTextArea,
	MInputDatepicker,
	MSelect,
	MLabeledSelect,
	MChoice,
	MChoices,
	MCheckbox,
	MInputNumber,
	MTooltip,
	MErrors,
	BaseDescription,
	BaseHeaderComponent,
	BaseHowItWorks,
	BaseMenu,
	BaseTopBanner,
	HowItWorksItem,
	MenuItem,
	Faq,
	FaqAccordion
}

export function createNameFromVModelExpr(component) {
	// automatically creates name from v-model expression
	const model = component.$vnode.data.model;
	if (model && model.expression)
		return [model.expression, component._uid].join('-').replace('.', '-');
}

export function loadComponentEntryPoints(componentEntryPoint) {
	let registry = {}
	componentEntryPoint.keys().forEach(key => {
		let module = componentEntryPoint(key).default;
		if (isObject(module) && isFunction(module.mount))
			// install only components with 'mount' function in default export
			registry[path.basename(path.dirname(key))] = module;
	});
	return registry;
}
